import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { chUpdateAllPatientGynaecologyMutation } from "@/modules/patients/services/ch/__generated__/chUpdateAllPatientGynaecologyMutation.graphql"
import { chUpdateAllPatientGynaecologyMutation as chMutation } from "@/modules/patients/services/ch/chUpdateAllPatientGynaecologyMutation"
import { deUpdateAllPatientGynaecologyMutation } from "@/modules/patients/services/de/__generated__/deUpdateAllPatientGynaecologyMutation.graphql"
import { deUpdateAllPatientGynaecologyMutation as deMutation } from "@/modules/patients/services/de/deUpdateAllPatientGynaecologyMutation"

const useUpdateAllPatientGynaecologyMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutation<chUpdateAllPatientGynaecologyMutation & deUpdateAllPatientGynaecologyMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<chUpdateAllPatientGynaecologyMutation & deUpdateAllPatientGynaecologyMutation>) => {
      commit(config)
    },
    [commit],
  )
  return [commitHandler]
}

export { useUpdateAllPatientGynaecologyMutation }
